import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { MoreHorizontal } from 'lucide-react';
import type { ReactNode } from 'react';
import { Tooltip } from './tooltip';

export type RowAction = {
  key: string; icon: ReactNode; label: string; onClick: () => void; danger?: boolean; disabled?: boolean;
};

export function RowActions({ primary = [], overflow = [] }: { primary?: RowAction[]; overflow?: RowAction[] }) {
  return <div className="bv-row-actions">
    {primary.map((action) => (
      <Tooltip content={action.label} key={action.key}>
        <button className="bv-button bv-button--quiet bv-icon-button" type="button" aria-label={action.label}
          disabled={action.disabled} onClick={action.onClick}>
          {action.icon}
        </button>
      </Tooltip>
    ))}
    {overflow.length > 0 && (
      <DropdownMenu.Root>
        <Tooltip content="More actions">
          <DropdownMenu.Trigger asChild>
            <button className="bv-button bv-button--quiet bv-icon-button" type="button" aria-label="More actions">
              <MoreHorizontal aria-hidden="true" size={18} />
            </button>
          </DropdownMenu.Trigger>
        </Tooltip>
        <DropdownMenu.Portal>
          <DropdownMenu.Content className="bv-dropdown" align="end" sideOffset={4}>
            {overflow.map((action) => (
              <DropdownMenu.Item
                key={action.key}
                className={`bv-dropdown__item${action.danger ? ' bv-dropdown__item--danger' : ''}`}
                disabled={action.disabled ?? false}
                onSelect={() => action.onClick()}
              >
                {action.icon}<span>{action.label}</span>
              </DropdownMenu.Item>
            ))}
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    )}
  </div>;
}
